import app from 'flarum/forum/app';
import Icon from 'flarum/common/components/Icon';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
let ProfileMessageComposerClass = null;
export default async function getProfileMessageComposer() {
  if (ProfileMessageComposerClass) return ProfileMessageComposerClass;
  const ComposerBody = await flarum.reg.asyncModuleImport('flarum/forum/components/ComposerBody');
  ProfileMessageComposerClass = class ProfileMessageComposer extends ComposerBody {
    static initAttrs(attrs) {
      super.initAttrs(attrs);
      const isEdit = !!attrs.editMessage;
      attrs.placeholder = attrs.placeholder || extractText(app.translator.trans('ralkage-profile-messages.forum.composer.placeholder'));
      attrs.submitLabel = attrs.submitLabel || app.translator.trans(isEdit ? 'ralkage-profile-messages.forum.composer.save_button' : 'ralkage-profile-messages.forum.composer.submit_button');
      attrs.confirmExit = attrs.confirmExit || extractText(app.translator.trans('ralkage-profile-messages.forum.composer.confirm_exit'));
      if (isEdit) {
        attrs.originalContent = attrs.editMessage.content();
      }
    }
    oninit(vnode) {
      super.oninit(vnode);
      this.previewHtml = '';
      this.previewLoading = false;
      this.showPreview = false;
    }
    headerItems() {
      const items = super.headerItems();
      const user = this.attrs.user;
      const isEdit = !!this.attrs.editMessage;
      let heading;
      let iconName;
      if (isEdit) {
        iconName = 'fas fa-pencil-alt';
        heading = app.translator.trans('ralkage-profile-messages.forum.composer.edit_heading');
      } else if (this.attrs.parentId) {
        iconName = 'fas fa-reply';
        heading = app.translator.trans('ralkage-profile-messages.forum.composer.reply_heading', {
          username: m(Link, {
            href: app.route.user(user)
          }, username(user))
        });
      } else {
        iconName = 'fas fa-comment-dots';
        heading = app.translator.trans('ralkage-profile-messages.forum.composer.heading', {
          username: m(Link, {
            href: app.route.user(user)
          }, username(user))
        });
      }
      items.add('title', m("h3", null, m(Icon, {
        name: iconName
      }), ' ', heading));
      return items;
    }
    jumpToPreview(e) {
      if (e) e.preventDefault();
      this.showPreview = !this.showPreview;
      if (this.showPreview) {
        this.loadPreview();
      }
      m.redraw();
    }
    loadPreview() {
      const content = this.composer.fields.content();
      if (!content || !content.trim()) {
        this.previewHtml = '';
        return;
      }
      this.previewLoading = true;
      app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/profile-messages/preview`,
        body: {
          content
        }
      }).then(response => {
        this.previewHtml = response.contentHtml || '';
        this.previewLoading = false;
        m.redraw();
      }).catch(() => {
        this.previewHtml = '<p>' + content.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</p>';
        this.previewLoading = false;
        m.redraw();
      });
    }
    view() {
      const view = super.view();
      if (this.showPreview) {
        const previewPanel = m("div", {
          className: "ProfileMessageComposer-preview"
        }, m("div", {
          className: "ProfileMessageComposer-previewHeader"
        }, m("strong", null, app.translator.trans('ralkage-profile-messages.forum.composer.preview_heading'))), m("div", {
          className: "ProfileMessageComposer-previewContent"
        }, this.previewLoading ? m(LoadingIndicator, null) : m.trust(this.previewHtml)));
        if (view && view.children) {
          view.children.push(previewPanel);
        }
      }
      return view;
    }
    data() {
      return {
        content: this.composer.fields.content()
      };
    }
    onsubmit() {
      this.loading = true;
      m.redraw();
      const isEdit = !!this.attrs.editMessage;
      if (isEdit) {
        this.attrs.editMessage.save(this.data()).then(msg => {
          if (this.attrs.onsubmit) {
            this.attrs.onsubmit(msg);
          }
          app.alerts.show({
            type: 'success'
          }, app.translator.trans('ralkage-profile-messages.forum.composer.saved_message'));
          this.composer.hide();
        }, this.loaded.bind(this));
      } else {
        const data = this.data();
        data.relationships = {
          user: this.attrs.user
        };
        if (this.attrs.parentId) {
          data.parentId = this.attrs.parentId;
        }
        app.store.createRecord('profile-messages').save(data).then(msg => {
          if (this.attrs.onsubmit) {
            this.attrs.onsubmit(msg);
          }
          app.alerts.show({
            type: 'success'
          }, app.translator.trans('ralkage-profile-messages.forum.composer.posted_message'));
          this.composer.hide();
        }, this.loaded.bind(this));
      }
    }
  };
  return ProfileMessageComposerClass;
}
flarum.reg.add('ralkage-profile-messages', 'forum/components/ProfileMessageComposer', getProfileMessageComposer);